import {Container} from "@chakra-ui/react"

function Heading(props){
    const {image,text}  = props
    return (
        <Container minW="full"  padding="0px" backgroundColor="#26a9e1" height = "auto" style={{postion : "relative"}}>
                <img style={{width : "100%"}} src={image} alt="img" />
                   <p style={{position : "absolute", top : "10%",left : "35%", fontSize:"45px", fontWeight:"600", fontFamily:"sans-serif", color : 'white', letterSpacing:"2px"}}>{text}</p>
        </Container>
    )
}

export default Heading;